// traceability: requirements: [NFR-008]
import { useEffect } from 'react';
import { useThemeStore } from '@/stores/themeStore';

export function useTheme() {
  const { mode, resolved, setMode, resolveTheme } = useThemeStore();

  useEffect(() => {
    resolveTheme();
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => resolveTheme();
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [resolveTheme]);

  return { mode, resolved, setMode };
}
